import React from 'react';

import logo from '../assets/images/image_logo_new.png';
import logoWhite from '../assets/images/image_logo_new_white.png';

export default function LogoButton(props) {
  const transparent = props.transparent;

  return (
    <div>
      <a href="/">
        <img src={transparent ? logoWhite : logo} className="logo-btn" alt="logo" />
      </a>
    </div>
  );
}
